import { useController } from 'react-hook-form'

import {
  InputAddressExtensionForm,
  UseInputAddressExtensionResult,
  useInputAddressExtension,
} from '@/domain/hooks/useInputAddressExtension'
import { useSandbox } from '@/domain/sandbox/useSandbox'
import { useWatchWalletModeActions } from '@/domain/wallet/useWatchWalletModeActions'

export interface UseWatchWalletDialogResult {
  inputAddressExtension: UseInputAddressExtensionResult
  field: ReturnType<typeof useController<InputAddressExtensionForm, 'address'>>['field']
  enableWatchWalletMode: () => Promise<void>
}

export function useWatchWalletDialog(closeDialog: () => void): UseWatchWalletDialogResult {
  const { enableWatchWalletMode: enableWatchWalletModeAction } = useWatchWalletModeActions()

  const inputAddressExtension = useInputAddressExtension()
  const { field } = useController<InputAddressExtensionForm, 'address'>({
    control: inputAddressExtension.form.control,
    name: 'address',
  })

  const { isInSandbox, disableSandbox } = useSandbox()

  async function enableWatchWalletMode(): Promise<void> {
    const address = inputAddressExtension.address
    if (!address) return
    if (isInSandbox) {
      disableSandbox()
    }

    enableWatchWalletModeAction(address)
    closeDialog()
  }

  return {
    inputAddressExtension,
    field,
    enableWatchWalletMode,
  }
}
